import { Form, Input, InputNumber, Select } from "antd";
import React from "react";

const AllowedMaximumReportUploadsName: React.FC = () => {
  return (
    <Form.Item
      name="additionalReportNames"
      label="Allowed Maximum Report Uploads Name"
      rules={[
        {
          required: true,
          message: "Allowed Maximum Report Uploads Name is required",
        },
      ]}
    >
      <Select
        mode="tags"
        style={{ width: "100%" }}
        defaultOpen={false}
        open={false}
        suffixIcon={null}
      />
      {/* <InputNumber style={{ width: "100%" }} /> */}
    </Form.Item>
  );
};

export default AllowedMaximumReportUploadsName;
